// packages/agent-kit/src/useAgents.ts
import useSWR from 'swr';
import { agentService, isApiError } from '@dopomogai/api-client';
import type { Agent } from '../types';
import { AgentKitError } from '../types';
import type { BareFetcher } from 'swr';

const AGENTS_CACHE_KEY = 'dopomogai/agents/list';

// SWR's fetcher type is generic. By defining it explicitly, we ensure correctness.
const agentsFetcher: BareFetcher<Agent[]> = async () => {
  const response = await agentService.listAgents();

  // Correctly use the type guard
  if (isApiError(response)) {
    // The compiler now knows `response` is an ApiErrorResponse
    throw new AgentKitError(response.message, response);
  }
  // The compiler now knows `response` is `AgentResponse[]`
  return response;
};

/**
 * Fetches the list of all available agents.
 * Handles loading, error, and data states automatically using SWR.
 */
export const useAgents = () => {
  // The fetcher function is passed directly.
  const { data, error, isLoading, mutate } = useSWR<Agent[], AgentKitError>(
    AGENTS_CACHE_KEY,
    agentsFetcher
  );

  return {
    agents: data,
    isLoading,
    error,
    mutate,
  };
};